import { useEffect, useRef } from "react";

/**
 * Returns the value passed during the *previous* render.
 *
 * This is the canonical implementation documented by React itself:
 * https://react.dev/reference/react/useRef#how-to-store-previous-value
 *
 * Reading the ref during render is fundamental to the hook's purpose
 * (returning the last-render's value), so `react-hooks/refs` is silenced.
 */
export const usePrevious = <T>(value: T): T | undefined => {
    const ref = useRef<T>(undefined);
    useEffect(() => {
        ref.current = value;
    });
    // eslint-disable-next-line react-hooks/refs
    return ref.current;
};
